import type { FC } from "react";

import dompurify from "isomorphic-dompurify";

import type { BlogItemImage } from "@jti/ui/components/BlogListing/BlogItem";

import type { RichTextComponent } from "../ArticleRestrictedContent";

import type { RestrictionMessageProps } from "./RestrictionMessage/RestrictionMessage";
import { RestrictionMessage } from "./RestrictionMessage/RestrictionMessage";

import styles from "./PreviewContent.module.scss";

const { sanitize } = dompurify;

export interface PreviewContentProps {
  primaryBtnUrl: string;
  secondaryBtnUrl: string;
  isLogged: boolean;
  isAvailable: boolean | null;
  previewContent?: string;
  restrictImage: BlogItemImage | null;
  primaryBtnUrlRestricted: string;
  isInEditor?: boolean;
  disableTiers?: boolean;
  richTextComponent: RichTextComponent;
}

export const PreviewContent: FC<PreviewContentProps> = ({
  primaryBtnUrl,
  secondaryBtnUrl,
  isLogged,
  isAvailable: isTierAvailableForUser,
  previewContent,
  restrictImage,
  primaryBtnUrlRestricted,
  isInEditor,
  disableTiers,
  richTextComponent,
}) => {
  // No tiers OR Logged and isTierAvailableForUser and not in editor
  if (disableTiers || (isLogged && isTierAvailableForUser && !isInEditor)) {
    return null;
  }

  const isEditorView = isInEditor ? false : isLogged;

  const restrictedMessageProps: RestrictionMessageProps = {
    primaryBtnUrl,
    secondaryBtnUrl,
    isLogged: isEditorView,
    primaryBtnUrlRestricted,
    restrictImage,
    isInEditor,
    richTextComponent,
  };

  return (
    <>
      {previewContent && (
        <div className={styles.previewContent} data-testid="previewContent">
          <div dangerouslySetInnerHTML={{ __html: sanitize(previewContent) }} />
        </div>
      )}
      <RestrictionMessage {...restrictedMessageProps} dataTestId="restrictionMessage" />
      {isInEditor && (
        <RestrictionMessage {...restrictedMessageProps} isLogged={true} dataTestId="restrictionMessageEditorPreview" />
      )}
    </>
  );
};
